/* Cart utilities using localStorage.
 * Product items:   { line_key, kind:"product", product_id, name, category, price, quantity, is_global, delivery_pincode }
 * Experience items:{ line_key, kind:"experience", experience_id, name, category:"experience", price, price_type, quantity, image_url }
 * Sourceable items:{ line_key, kind:"sourceable", name, category, source_description, price:0, price_type:"on_request", quantity, is_global:true }
 * `line_key` uniquely identifies a cart row (product_id for products, `exp:{id}` for experiences, `src:{index}:{name}` for sourceable).
 */
const KEY = "celebrai_cart";

const keyOf = (i) =>
  i.line_key || (i.kind === "experience" ? `exp:${i.experience_id}` : i.product_id);

export function getCart() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function setCart(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("cart-change"));
}

export function addToCart(item) {
  const cart = getCart();
  const lk = keyOf(item);
  const idx = cart.findIndex((c) => keyOf(c) === lk);
  if (idx >= 0) cart[idx].quantity += item.quantity || 1;
  else cart.push({ ...item, line_key: lk, quantity: item.quantity || 1 });
  setCart(cart);
}

export function removeFromCart(line_key) {
  setCart(getCart().filter((c) => keyOf(c) !== line_key));
}

export function clearCart() { setCart([]); }

export function cartTotal(items = getCart()) {
  return items.reduce((s, i) => {
    // Sourceable items are priced after admin sourcing — don't count them yet.
    if (i.kind === "sourceable") return s;
    // Experiences priced "on_request" don't contribute to the confirmed total.
    if (i.kind === "experience" && i.price_type === "on_request") return s;
    return s + (i.price || 0) * (i.quantity || 1);
  }, 0);
}
